import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function MerchantPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');

  // 인증 확인
  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem('merchant_auth');
    if (!isAuthenticated) {
      navigate('/merchant/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.removeItem('merchant_auth');
    sessionStorage.removeItem('merchant_username');
    navigate('/merchant/login');
  };

  const tabs = [
    { id: 'dashboard', label: '대시보드', icon: 'ri-dashboard-line' },
    { id: 'products', label: '상품 관리', icon: 'ri-shopping-bag-line' },
    { id: 'orders', label: '주문 관리', icon: 'ri-file-list-line' },
    { id: 'sales', label: '매출 관리', icon: 'ri-line-chart-line' },
    { id: 'talent', label: '달란트 정산', icon: 'ri-coin-line' }
  ];

  const products = [
    { id: 1, name: '성경 가죽 커버', price: 45000, stock: 50, sales: 124, status: '판매중' },
    { id: 2, name: '찬양 악보집', price: 28000, stock: 30, sales: 89, status: '판매중' },
    { id: 3, name: '십자가 목걸이', price: 35000, stock: 0, sales: 156, status: '품절' },
    { id: 4, name: '묵상 노트', price: 18000, stock: 100, sales: 203, status: '판매중' }
  ];

  const recentOrders = [
    { id: 1, customer: '김성도', product: '성경 가죽 커버', amount: 45000, talent: 4500, status: '배송완료', date: '2025-01-15' },
    { id: 2, customer: '이믿음', product: '찬양 악보집', amount: 28000, talent: 2800, status: '배송중', date: '2025-01-14' },
    { id: 3, customer: '박은혜', product: '십자가 목걸이', amount: 35000, talent: 3500, status: '배송준비', date: '2025-01-14' },
    { id: 4, customer: '최사랑', product: '묵상 노트', amount: 18000, talent: 1800, status: '주문확인', date: '2025-01-13' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="mb-8 flex items-center justify-between">
            <div>
              <h1 className="text-4xl font-bold text-gray-900 mb-2">가맹점 관리</h1>
              <p className="text-gray-600">상품과 주문을 관리하고 매출을 확인하세요</p>
            </div>
            <button
              onClick={handleLogout}
              className="px-4 py-2 bg-gray-600 text-white text-sm font-semibold rounded-lg hover:bg-gray-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-logout-box-line mr-2"></i>
              로그아웃
            </button>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
                <div className="text-center mb-6">
                  <div className="w-24 h-24 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-store-line text-4xl text-teal-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-1">믿음서점</h3>
                  <p className="text-sm text-gray-600">가맹점 ID: M12345</p>
                </div>
                <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-lg p-4">
                  <p className="text-sm text-gray-600 mb-1">이번 달 매출</p>
                  <p className="text-2xl font-bold text-gray-900">₩2,450,000</p>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`w-full px-6 py-4 flex items-center space-x-3 transition-colors cursor-pointer ${
                      activeTab === tab.id
                        ? 'bg-teal-50 text-teal-600 border-r-4 border-teal-600'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    <i className={`${tab.icon} text-xl`}></i>
                    <span className="font-medium">{tab.label}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="lg:col-span-3">
              {activeTab === 'dashboard' && (
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                        <i className="ri-shopping-bag-line text-2xl text-teal-600"></i>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">등록 상품</p>
                      <p className="text-3xl font-bold text-gray-900">48</p>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center mb-4">
                        <i className="ri-file-list-line text-2xl text-amber-600"></i>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">총 주문</p>
                      <p className="text-3xl font-bold text-gray-900">572</p>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                        <i className="ri-money-dollar-circle-line text-2xl text-green-600"></i>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">이번 달 매출</p>
                      <p className="text-2xl font-bold text-gray-900">₩2.45M</p>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                        <i className="ri-coin-line text-2xl text-blue-600"></i>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">달란트 정산</p>
                      <p className="text-2xl font-bold text-gray-900">245K</p>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl shadow-sm p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-6">최근 주문</h3>
                    <div className="overflow-x-auto">
                      <table className="w-full">
                        <thead>
                          <tr className="border-b border-gray-200">
                            <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">주문번호</th>
                            <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">고객명</th>
                            <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">상품</th>
                            <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">금액</th>
                            <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">상태</th>
                            <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">날짜</th>
                          </tr>
                        </thead>
                        <tbody>
                          {recentOrders.map((order) => (
                            <tr key={order.id} className="border-b border-gray-100 hover:bg-gray-50">
                              <td className="py-4 px-4 text-sm text-gray-900">#{order.id.toString().padStart(6, '0')}</td>
                              <td className="py-4 px-4 text-sm text-gray-900">{order.customer}</td>
                              <td className="py-4 px-4 text-sm text-gray-900">{order.product}</td>
                              <td className="py-4 px-4 text-sm text-gray-900">₩{order.amount.toLocaleString()}</td>
                              <td className="py-4 px-4">
                                <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                                  order.status === '배송완료' ? 'bg-green-100 text-green-700' :
                                  order.status === '배송중' ? 'bg-blue-100 text-blue-700' :
                                  order.status === '배송준비' ? 'bg-amber-100 text-amber-700' :
                                  'bg-gray-100 text-gray-700'
                                }`}>
                                  {order.status}
                                </span>
                              </td>
                              <td className="py-4 px-4 text-sm text-gray-600">{order.date}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <h3 className="text-lg font-bold text-gray-900 mb-4">인기 상품</h3>
                      <div className="space-y-3">
                        <div className="flex items-center justify-between">
                          <span className="text-sm text-gray-700">묵상 노트</span>
                          <span className="text-sm font-semibold text-gray-900">203개</span>
                        </div>
                        <div className="flex items-center justify-between">
                          <span className="text-sm text-gray-700">십자가 목걸이</span>
                          <span className="text-sm font-semibold text-gray-900">156개</span>
                        </div>
                        <div className="flex items-center justify-between">
                          <span className="text-sm text-gray-700">성경 가죽 커버</span>
                          <span className="text-sm font-semibold text-gray-900">124개</span>
                        </div>
                      </div>
                    </div>

                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <h3 className="text-lg font-bold text-gray-900 mb-4">월별 매출 추이</h3>
                      <div className="space-y-3">
                        <div>
                          <div className="flex items-center justify-between mb-1">
                            <span className="text-sm text-gray-600">1월</span>
                            <span className="text-sm font-semibold text-gray-900">₩2.45M</span>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2">
                            <div className="bg-teal-600 h-2 rounded-full" style={{ width: '85%' }}></div>
                          </div>
                        </div>
                        <div>
                          <div className="flex items-center justify-between mb-1">
                            <span className="text-sm text-gray-600">12월</span>
                            <span className="text-sm font-semibold text-gray-900">₩2.88M</span>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2">
                            <div className="bg-teal-600 h-2 rounded-full" style={{ width: '100%' }}></div>
                          </div>
                        </div>
                        <div>
                          <div className="flex items-center justify-between mb-1">
                            <span className="text-sm text-gray-600">11월</span>
                            <span className="text-sm font-semibold text-gray-900">₩2.12M</span>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2">
                            <div className="bg-teal-600 h-2 rounded-full" style={{ width: '74%' }}></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'products' && (
                <div className="bg-white rounded-xl shadow-sm p-6">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-xl font-bold text-gray-900">상품 관리</h3>
                    <button className="px-4 py-2 bg-teal-600 text-white text-sm font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
                      <i className="ri-add-line mr-2"></i>
                      상품 등록
                    </button>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead>
                        <tr className="border-b border-gray-200">
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">상품명</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">가격</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">재고</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">판매량</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">상태</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">관리</th>
                        </tr>
                      </thead>
                      <tbody>
                        {products.map((product) => (
                          <tr key={product.id} className="border-b border-gray-100 hover:bg-gray-50">
                            <td className="py-4 px-4 text-sm font-medium text-gray-900">{product.name}</td>
                            <td className="py-4 px-4 text-sm text-gray-900">₩{product.price.toLocaleString()}</td>
                            <td className="py-4 px-4 text-sm text-gray-900">{product.stock}</td>
                            <td className="py-4 px-4 text-sm text-gray-900">{product.sales}</td>
                            <td className="py-4 px-4">
                              <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                                product.status === '판매중' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                              }`}>
                                {product.status}
                              </span>
                            </td>
                            <td className="py-4 px-4">
                              <button className="text-teal-600 hover:text-teal-700 mr-3 cursor-pointer">
                                <i className="ri-edit-line text-lg"></i>
                              </button>
                              <button className="text-red-600 hover:text-red-700 cursor-pointer">
                                <i className="ri-delete-bin-line text-lg"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {activeTab === 'orders' && (
                <div className="bg-white rounded-xl shadow-sm p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-6">주문 관리</h3>
                  <div className="space-y-4">
                    {recentOrders.map((order) => (
                      <div key={order.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-all">
                        <div className="flex items-center justify-between mb-3">
                          <div>
                            <p className="font-semibold text-gray-900">주문번호: #{order.id.toString().padStart(6, '0')}</p>
                            <p className="text-sm text-gray-600">{order.date}</p>
                          </div>
                          <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                            order.status === '배송완료' ? 'bg-green-100 text-green-700' :
                            order.status === '배송중' ? 'bg-blue-100 text-blue-700' :
                            order.status === '배송준비' ? 'bg-amber-100 text-amber-700' :
                            'bg-gray-100 text-gray-700'
                          }`}>
                            {order.status}
                          </span>
                        </div>
                        <div className="grid grid-cols-2 gap-4 mb-3">
                          <div>
                            <p className="text-sm text-gray-600">고객명</p>
                            <p className="font-medium text-gray-900">{order.customer}</p>
                          </div>
                          <div>
                            <p className="text-sm text-gray-600">상품</p>
                            <p className="font-medium text-gray-900">{order.product}</p>
                          </div>
                        </div>
                        <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                          <div>
                            <p className="text-sm text-gray-600">결제 금액</p>
                            <p className="font-bold text-gray-900">₩{order.amount.toLocaleString()}</p>
                          </div>
                          <button className="px-4 py-2 bg-teal-600 text-white text-sm font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
                            상세보기
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {activeTab === 'sales' && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-xl shadow-lg p-8 text-white">
                    <p className="text-lg mb-2">총 매출액</p>
                    <p className="text-5xl font-bold mb-6">₩28,450,000</p>
                    <div className="grid grid-cols-3 gap-4">
                      <div className="bg-white/20 rounded-lg p-4">
                        <p className="text-sm text-teal-100 mb-1">이번 달</p>
                        <p className="text-2xl font-bold">₩2.45M</p>
                      </div>
                      <div className="bg-white/20 rounded-lg p-4">
                        <p className="text-sm text-teal-100 mb-1">지난 달</p>
                        <p className="text-2xl font-bold">₩2.88M</p>
                      </div>
                      <div className="bg-white/20 rounded-lg p-4">
                        <p className="text-sm text-teal-100 mb-1">평균</p>
                        <p className="text-2xl font-bold">₩2.37M</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl shadow-sm p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-6">월별 매출 상세</h3>
                    <div className="space-y-4">
                      {['1월', '12월', '11월', '10월', '9월'].map((month, index) => {
                        const amounts = [2450000, 2880000, 2120000, 2340000, 2560000];
                        return (
                          <div key={month} className="flex items-center justify-between pb-4 border-b border-gray-100 last:border-0">
                            <span className="font-medium text-gray-900">{month}</span>
                            <span className="text-lg font-bold text-gray-900">₩{amounts[index].toLocaleString()}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'talent' && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl shadow-lg p-8 text-white">
                    <p className="text-lg mb-2">달란트 정산 내역</p>
                    <div className="flex items-center space-x-3 mb-6">
                      <i className="ri-coin-line text-5xl"></i>
                      <p className="text-5xl font-bold">245,000</p>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-white/20 rounded-lg p-4">
                        <p className="text-sm text-amber-100 mb-1">이번 달 적립</p>
                        <p className="text-2xl font-bold">+24,500</p>
                      </div>
                      <div className="bg-white/20 rounded-lg p-4">
                        <p className="text-sm text-amber-100 mb-1">정산 대기</p>
                        <p className="text-2xl font-bold">12,300</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl shadow-sm p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-6">달란트 정산 내역</h3>
                    <div className="space-y-4">
                      {[
                        { date: '2025-01-15', amount: 4500, product: '성경 가죽 커버', status: '완료' },
                        { date: '2025-01-14', amount: 2800, product: '찬양 악보집', status: '완료' },
                        { date: '2025-01-14', amount: 3500, product: '십자가 목걸이', status: '대기' },
                        { date: '2025-01-13', amount: 1800, product: '묵상 노트', status: '완료' }
                      ].map((item, index) => (
                        <div key={index} className="flex items-center justify-between pb-4 border-b border-gray-100 last:border-0">
                          <div>
                            <p className="font-medium text-gray-900">{item.product}</p>
                            <p className="text-sm text-gray-600">{item.date}</p>
                          </div>
                          <div className="text-right">
                            <p className="text-lg font-bold text-amber-600">+{item.amount.toLocaleString()}</p>
                            <span className={`text-xs px-2 py-1 rounded-full ${
                              item.status === '완료' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'
                            }`}>
                              {item.status}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
